module.exports = __webpack_public_path__ + "img/logo.07e2b9bc.png";